<template>
  <!-- 班级 -->
  <div class="my-grade">
    <div class="head" @click="handleAddGrade" v-if="isAddBtn">
      <div class="head-box">
        <img src="../../assets/images/grade/icon-grade.png" alt="" class="icon-grade" />
        <p class="title">创建班级</p>
      </div>
    </div>
    <div class="grade-box" :class="{ 'isWhiteUser': isWhiteUser }" v-if="list.length > 0">
      <van-list v-model="loading" v-if="list.length > 0 && !isNone" :finished="finished" finished-text="我是有底线的"
        loading-text="正在加载..." @load="onLoad">
        <div class="grade-list" v-for="item in list" :key="item.id" @click="handleHomePage(item.id)">
          <div class="list-head">
            <div class="head-left">
              <p class="left-title">{{ item && item.className }}<span class="icon-bg"></span></p>
              <p class="left-time">创建时间:{{ item && item.createTimeTxt }}</p>
            </div>
            <div class="head-right">
              <div class="right-box">
                <span class="mr14">已加入:{{ item && item.joinNum }}</span>
                <span>未加入:{{ item && item.inviteNum }}</span>
              </div>
              <div class="right-set" v-if="[1, 2].includes(item.roleType)" @click.stop="handleSet(item.id)">
                <img src="../../assets/images/grade/icon-set.png" alt="" class="icon-setting" />
                <span>设置</span>
                <img src="../../assets/images/grade/min-icon-right.png" alt="" class="icon-right" />
              </div>
            </div>
          </div>
          <ul class="list-bottom">
            <li class="bottom-list">
              <img src="../../assets/images/grade/icon-illness.png" alt="" class="icon-illness">
              <p class="title">{{ item && item.diseaseName }}</p>
            </li>
            <li class="bottom-list">
              <img src="../../assets/images/grade/icon-new.png" alt="" class="icon-new">
              <p class="new-title">{{ item && item.technologyName }}</p>
            </li>
          </ul>
        </div>
      </van-list>
    </div>
    <div class="none" v-else-if="isNone && list.length <= 0">
      <div class="none-box">
        <img src="../../assets/images/home/live_none.png" class="none-img" alt="">
        <div class="none-txt">暂无内容</div>
      </div>
    </div>
    <div class="delModel" v-if="isCodeModel">
      <div class="model-dissolve">
        <p class="delModel-head">提示</p>
        <p class="title">{{ message }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import withRouteTracking from '@/utils/withRouteTracking'
import { getClassList, getUserPerss, whiteUser } from '@/api/grade'
// import { PEROLES, CDROLES } from '@/utils/configRoles.js'
const UserProfile = {
  name: 'grade',
  data () {
    return {
      isCodeModel: false,
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      load: false,
      isNone: false,
      list: [],
      isAddBtn: false,
      // userList: [...PEROLES, ...CDROLES],
      // addUserList: PEROLES,
      message: '',
      isWhiteUser: false
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    ADMINROLES() {
      return JSON.parse(`${sessionStorage.getItem('gradeRolesList')}`).ADMINROLES
    },
    EDITORROLES() {
      return JSON.parse(`${sessionStorage.getItem('gradeRolesList')}`).EDITORROLES
    },
    userList() {
      return [...this.ADMINROLES, ...this.EDITORROLES]
    },
    addUserList() {
      return this.EDITORROLES
    }
  },
  mounted () {
    sessionStorage.removeItem('createGrade')
    sessionStorage.removeItem('classId')
    sessionStorage.removeItem('changeGradeTabActive')
    sessionStorage.removeItem('selectGradeCurrentJourney')
    whiteUser({ email: this.userInfo.email }).then(resUser => {
      this.isWhiteUser = resUser.data
      if (this.isWhiteUser) {
        sessionStorage.setItem('isWhiteUser', JSON.stringify(resUser.data))
      }
      if (this.userInfo.memberType === 1) { // 用户
        this.handlegetUserPerss()
      } else if (this.isWhiteUser) { // 术者
        this.onLoad()
      }
    }).catch(err => console.log(err))
  },
  methods: {
    // 获取用户角色/等级
    handlegetUserPerss () {
      getUserPerss(this.userInfo.id).then(res => {
        let data = res.data
        if (data) {
          if (this.userList.includes(data)) {
            this.onLoad()
          }
          if (this.addUserList.includes(data)) {
            this.isAddBtn = true
            this.onLoad()
          }
        } else if (this.isWhiteUser) {
          this.onLoad()
        } else {
          this.handleMsg()
        }
      })
    },
    handleMsg () {
      this.message = '您无班级列表数据，已为您跳转至iEP首页。'
      this.isCodeModel = true
      this.settime = setTimeout(() => {
        this.$router.push({
          path: '/home'
        })
      }, 3000)
    },
    // 添加班级
    handleAddGrade () {
      sessionStorage.removeItem('createGrade')
      this.$router.push({
        path: '/createGrade',
      })
    },
    handleHomePage (id) {
      sessionStorage.removeItem('createGrade')
      this.$router.push({
        path: '/gradeHomePage',
        query: {
          classId: id
        }
      })
    },
    onLoad () {
      if (this.load) {
        return
      }
      this.load = true
      const params = {
        userId: this.userInfo.id,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        email: this.userInfo.email
      }
      // if (this.isWhiteUser) {
      // }
      getClassList(params).then(res => {
        this.load = false
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        this.list = this.list.concat(res.data.list)
        this.list.forEach(acc => {
          acc.diseaseName = acc.diseaseList && acc.diseaseList.map(item => item.diseaseName).join(',')
          acc.technologyName = acc.technologyList && acc.technologyList.map(item => item.technologyName).join(',')
          acc.createTimeTxt = this.$moment(acc.createTime * 1).format('YYYY.MM.DD')
        })
        // 加载状态结束
        this.loading = false
        if (this.list.length <= 0) {
          this.isNone = true
        } else {
          this.isNone = false
        }
        this.pageNum++
      })
    },

    handleSet (id) {
      this.$router.push({
        path: '/createGrade',
        query: {
          classId: id,
        }
      })
    },
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.my-grade {
  position: relative;
  background: #F9F8F7;
  padding: 16px 10px 0;
  box-sizing: border-box;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;

  &::before {
    content: "";
    width: 100%;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    height: 258px;
    background: linear-gradient(180deg, #eb1700 0%, rgba(235, 23, 0, 0) 100%);
  }

  .head {
    width: 100%;
    background: #fff;
    height: 70px;
    border-radius: 8px;
    margin: 0 auto 8px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 16px 30px;
    box-sizing: border-box;

    .head-box {
      display: flex;
      align-items: center;

      .icon-grade {
        width: 38px;
        height: 37px;
        margin-right: 8px;
      }

      .title {
        font-family: PingFang HK, PingFang HK;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        line-height: 20px;
      }
    }
  }

  .grade-box {
    height: calc(100% - 78px);
    overflow-y: auto;
    position: relative;

    &.isWhiteUser {
      height: 100%;
    }

    .grade-list {
      background: #fff;
      height: 152px;
      margin-bottom: 8px;
      border-radius: 12px;
      position: relative;

      .list-head {
        padding: 12px 12px 14px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border-bottom: 1px solid #F0F0F0;
        position: relative;
        z-index: 2;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;

        .head-left {
          // flex: 1;
          position: relative;
          width: 62%;

          .left-title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 600;
            font-size: 14px;
            color: #282828;
            line-height: 20px;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: relative;
            z-index: 2;

            .icon-bg {
              position: relative;
              display: inline-block;
              left: -31px;
              top: 0;
              background: url("../../assets/images/grade/icon.png") no-repeat center center / 100% 100%;
              width: 49px;
              height: 10px;
            }
          }

          .left-time {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 12px;
            color: #6A7481;
            line-height: 20px;
          }
        }

        .head-right {
          width: 40%;

          .right-box {
            display: flex;
            justify-content: space-between;

            span {
              font-family: PingFang HK, PingFang HK;
              font-weight: 400;
              font-size: 13px;
              color: rgba(0, 0, 0, 0.6);
              line-height: 20px;
            }

            .mr14 {
              margin-right: 14px;
            }
          }

          .right-set {
            margin-top: 4px;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .icon-setting {
              width: 13px;
              height: 13px;
              margin-right: 2px;
            }

            span {
              font-family: PingFang HK, PingFang HK;
              font-weight: 400;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.6);
              line-height: 20px;
              margin-right: 3px;
            }

            .icon-right {
              width: 6px;
              height: 9px;
            }
          }
        }
      }

      .list-bottom {
        padding: 9px 12px 14px;

        .bottom-list {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }

          .icon-illness {
            width: 34px;
            height: 23px;
            margin-right: 4px;
            margin-left: 11px;
          }

          .icon-new {
            width: 45px;
            height: 22px;
            margin-right: 4px;
          }

          .title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .new-title {
            flex: 1;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 13px;
            color: #000000;
            line-height: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .bottom-title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #6A7481;
            line-height: 20px;
          }
        }
      }
    }
  }

  .none {
    display: block;
    width: 100%;
    position: relative;
    overflow-x: hidden;
    height: calc(100% - 78px);
    background: #f0f1f6;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    .none-box {
      position: absolute;
      top: 50%;
      left: 50%;
      right: 0;
      bottom: 0;
      width: 185px;
      transform: translate(-50%, -50%);
      text-align: center;

      .none-img {
        width: 185px;
      }

      .none-txt {
        text-align: center;
        font-size: 12px;
        color: #949BA5;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }

  .delModel {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 26px;

    .model-dissolve {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -160px;
      margin-top: -98px;
      background: url("../../assets/images/grade/model-bg.png") no-repeat center center / 100% 100%;
      width: 320px;
      height: 195px;
      padding: 15px 17px 16px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .delModel-head {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 17px;
        color: #000000;
        line-height: 20px;
        margin-bottom: 20px;
        text-align: center;
      }

      .title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
        line-height: 26px;
        margin: 20px 50px;
        text-align: center;
        flex: 1;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/grade/index.vue